import { ICollection } from '@tacans/shared-marketplace-layer';
import Link from 'next/link';
import React, { memo } from 'react';
import { generatePath, RouteE } from 'src/constants/pages.constants';
import { useAvatarAssets } from 'src/features/common/collection/hooks/use-avatar-assets';
import { Avatar } from 'src/ui/common/atoms/avatar';
import { Typography } from 'src/ui/common/atoms/typography';
import { wipeHtml } from 'src/utils/html.utils';
import { StyledWrapper } from './styles';

export const CollectionListLabel: React.VFC<{ collection: ICollection }> = memo(({ collection }) => {
    const assets = useAvatarAssets({ collection });

    const url = generatePath(RouteE.COLLECTION_VIEW, { id: collection.id });

    return (
        <Link href={url} prefetch={false}>
            <a>
                <StyledWrapper alignItems="center">
                    <Avatar size={20} variant="square" src={assets.src} borderRadius="50" />
                    <Typography variant="title" size="xs" sizeSm="sm" overflowLines={1}>
                        {wipeHtml(collection.name)}
                    </Typography>
                </StyledWrapper>
            </a>
        </Link>
    );
});
